import { eachMinuteOfInterval, format, sub } from "date-fns";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { SparklesIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import { TwButton, TwDropzone, TwInputGroup } from "../../../components/tailwind";
import TwQuillEditor from "../../../components/tailwind/TwQuillEditor";
import { wrapContentIfNeeded } from "../../../helpers";
import { useLocalStorage } from "../../../hooks";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import { loadingState } from "../../../redux/reducers/loadingReducer";
import { schoolState } from "../../../redux/reducers/schoolReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForEvent, getUrlForUsers } from "../../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function GeneralTab({
  title,
  edit,
  formValues,
  setFormValues,
  formValidationErrors,
  setTabCurrentState,
  handleUpdate,
  handleCancel,
}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);
  const loadingReduxState = useSelector(loadingState);
  const schoolReduxState = useSelector(schoolState);
  const sessionDataToDisplay = dashboardReduxState.eventScheduleData ? dashboardReduxState.eventScheduleData : {};
  const eventInfo = sessionDataToDisplay?.eventId ? sessionDataToDisplay.eventId : {};
  const [eventcategoryOpts, setEventCategoryOpts] = React.useState([]);
  const [categoryOpts, setCategoryOpts] = React.useState([]);
  const [sessionsOpts, setSessionsOpts] = React.useState([]);
  const [durationOpts, setDurationOpts] = React.useState([]);
  const [seatsOpts, setSeatsOpts] = React.useState([]);

  const [isSubmitting, setSubmitting] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({});
  const [imageProgress, setImageProgress] = React.useState(0);
  const [gptLoading, setGptLoading] = React.useState(false);

  React.useEffect(() => {
    let sesOpts = [];
    let durOpts = [];
    let seatsOptions = [];
    let catOpts = [...schoolReduxState.schoolCategories];
    for (let i = 1; i < 101; i++) {
      sesOpts.push(String(i));
      seatsOptions.push(String(i));
    }

    let intervalOptions = {
      start: new Date(Date.now()),
      end: new Date(Date.now()),
    };

    intervalOptions.start = intervalOptions.start.setMinutes(15);
    intervalOptions.start = new Date(intervalOptions.start).setHours(0);

    intervalOptions.end = intervalOptions.end.setMinutes(0);
    intervalOptions.end = new Date(intervalOptions.end).setHours(8);

    durOpts = eachMinuteOfInterval(intervalOptions, { step: 15 });
    durOpts = durOpts.map((opt) =>
      format(sub(opt, { hours: 0 }), "K 'hr' m 'min'")
    );

    // setCategoryOpts([...catOpts]);
    setSessionsOpts([...sesOpts]);
    setDurationOpts([...durOpts]);
    setSeatsOpts([...seatsOptions]);
  }, [schoolReduxState]);

  React.useEffect(() => {
    if (formValues.freeCancellation === false) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        cancellationPeriod: "",
      }));
    }
  }, [formValues.freeCancellation]);

  React.useEffect(() => {
    (async () => {
      const config = {
        method: "get",
        url: `${getUrlForUsers()}categories/get?businesType=event`,
      };
      const request = await axiosInstance(config);
      setEventCategoryOpts(request.data.data);
      // setCategoryOpts(request.data.data);
      if (request.data?.data?.length) {
        const allEventCategories = request.data.data.map((item) => [...item.category]).flat()
        const selectedeventCategory = allEventCategories.find((catItem, idx) => {
          if (edit && edit !== "drafted") {
            return (catItem._id === eventInfo.eventCategory)
          } else {
            if (Object.keys(formValues.eventCategory).length && formValues.eventCategory._id != undefined) {
              return (catItem._id === formValues.eventCategory._id)
            }
            return (idx === 0)
          }
        })

        setFormValues((prevValues) => ({
          ...prevValues,
          eventCategory: selectedeventCategory,
        }));

        const selectedCat = selectedeventCategory.category.find((catItem, idx) => {
          if (edit && edit !== "drafted") {
            return (catItem._id === eventInfo.catId)
          } else {
            if (Object.keys(formValues.categories).length && formValues.categories._id != undefined) {
              return (catItem._id === formValues.categories._id)
            }
            return (idx === 0)
          }
        })
        setCategoryOpts(selectedeventCategory?.category ? selectedeventCategory.category : []);
        setFormValues((prevValues) => ({
          ...prevValues,
          categories: selectedCat,
        }));
      }
    })();
  }, []);

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setSubmitting(true);

    const errors = {};
    if (!formValues.photo) {
      errors.photo = t("errors.required");
    }
    if (!Object.keys(formValues.eventCategory).length) {
      errors.eventCategory = t("errors.required");
    }
    if (!Object.keys(formValues.categories).length) {
      errors.categories = t("errors.required");
    }
    if (!formValues.eventName) {
      errors.eventName = t("errors.required");
    }
    if (!formValues.classDescription) {
      errors.classDescription = t("errors.required");
    } else if (formValues.classDescription.length < 5) {
      errors.classDescription = t("errors.aboutusMinLength", { businessName: title });
    }
    /* if (!formValues.price) {
      errors.price = t("errors.required");
    }
    if (!formValues.seats) {
      errors.seats = t("errors.required");
    } */
    if (!formValues.duration) {
      errors.duration = t("errors.required");
    }
    if (title === "Course" && !formValues.sessions) {
      errors.sessions = t("errors.required");
    }
    /* if (formValues.freeCancellation) {
      if (!formValues.cancellationPeriod) {
        errors.cancellationPeriod = t("errors.required");
      }
    } */
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }

    if (!formValues.whatToCarry) {
      setFormValues((prevValues) => ({
        ...prevValues,
        whatToCarry: "Nothing specified",
      }));
    }

    const durationSplit = formValues.durationstring.split(" ");
    const durationInNum =
      Number(durationSplit[0]) * 60 + Number(durationSplit[2]);
    setFormValues((prevValues) => ({
      ...prevValues,
      duration: durationInNum,
    }));

    setSubmitting(false);
    setTabCurrentState("2");

  };

  const clearFormValues = () => {
    setFormValues({
      photo: "",
      categories: "",
      eventName: "",
      tagLine: "",
      classDescription: "",
      price: "",
      seats: "",
      duration: "",
      sessions: "",
      whatToCarry: "",
      freeCancellation: true,
      cancellationPeriod: "24hrs",
      inviteCodeOnlyBooking: false,
      paymentAtVenue: false,
    });
  };

  const handleGenerate = async () => {
    // // handleFormValueChange({ target: { name: "classDescription", value: wrapContentIfNeeded("asdasdasdasdsa") } })
    // return false;
    if (!formValues.eventName) return alert(t("errors.enterEventNameError"));
    setGptLoading(true);

    try {
      const request = await axiosInstance.post(
        `${getUrlForEvent()}generateOpenAiMessage`,
        {
          keywords: formValues.eventName,
        }
      );
      if (request.status === 200) {
        if (request.data.statusCode === 200 && request.data.data) {
          setFormValues((prevValues) => ({
            ...prevValues,
            classDescription: wrapContentIfNeeded(request.data.data.trim()),
          }));
          return;
        } else if (request.data.statusCode === 403) {
          addErrorToast(t("errors.somethingIsWrong"));
          setSubmitting(false);
        } else {
          addErrorToast(t("errors.somethingIsWrong"));
        }
      }
      // setDescription(content.trim());
      // handleFormValueChange({ target: { name: "classDescription", value: wrapContentIfNeeded(content.trim()) } })

    } catch (err) {
      console.error("OpenAI API error:", err);
      alert(t("errors.failedToGenerateDescription"));
    } finally {
      setGptLoading(false);
    }
  };

  React.useEffect(() => {
    if (formValidationErrors) {
      setFormErrors(formValidationErrors)
    }
  }, [formValidationErrors]);

  return (
    <div className={"flex flex-col gap-4"}>
      <TwDropzone
        name={"photo"}
        uploadBtnText={formValues.photo !== "" ? t("myEvents.changeBanner") : t("myEvents.addBanner")}
        errors={formErrors}
        value={formValues.photo || ""}
        onChange={(image) => {
          setFormValues(prevValues => ({
            ...prevValues,
            photo: image,
          }))
        }}
      />
      <TwInputGroup
        // variant={"line"}
        label={<label className="text-secondary font-bold text-xl">{t("myEvents.eventName")}</label>}
        placeholder={t("myEvents.eventName")}
        name={"eventName"}
        // inputClass={"mb-2 "}
        outerClassName={"md:!max-w-full"}
        value={formValues.eventName}
        onChange={handleFormValueChange}
        errors={formErrors}
      // className="!py-3 md:pl-2.5"
      />
      {/* <TwInputGroup
        label={t("myEvents.tagLine")}
        name={"tagLine"}
        value={formValues.tagLine}
        onChange={handleFormValueChange}
        errors={formErrors}
      /> */}
      {/* <TwSelectGroup
        label={t("myEvents.eventType")}
        placeholder={t("myEvents.selectEventType")}
        name={"eventCategory"}
        //   })
        // ))}
        options={eventcategoryOpts[0]?.category ? eventcategoryOpts[0].category.map((cat, idx) => {

          return { value: JSON.stringify(cat), title: cat.name }
        }) : []}
        defaultValue={JSON.stringify(formValues.eventCategory)}
        value={JSON.stringify(formValues.eventCategory)}
        onChange={(event) => {
          let optionData = JSON.parse(event.target.value)
          setFormValues((prevValues) => ({
            ...prevValues,
            eventCategory: optionData,
            // categories: "",
            categories: optionData.category.length > 0 ? optionData.category[0] : "",
          }));
          if (optionData.category) {
            setCategoryOpts(optionData.category);
          }
        }}
        errors={formErrors} /> */}
      {/* <TwSelectGroup
        label={"Category"}
        placeholder={"Select Category"}
        name={"categories"}
        options={categoryOpts.length ? categoryOpts.map((category, idx) => {
          return { value: JSON.stringify(category), title: category.name }
        }) : []}
        defaultValue={JSON.stringify(formValues.categories)}
        value={JSON.stringify(formValues.categories)}
        onChange={(event) => {
          setFormValues((prevValues) => ({
            ...prevValues,
            categories: JSON.parse(event.target.value),
          }));
        }}
        errors={formErrors} /> */}
      <label className="font-bold text-xl">{t("myEvents.aboutThisEvent")}</label>
      <div className="w-full flex flex-col gap-4 p-4 border-2 border-bright-gray rounded-2xl">

        {/* <TwTextarea
          label={t("myEvents.aboutThisEvent")}
          name={"classDescription"}
          placeholder={
            t("myEvents.aboutThisEventPlaceholder")
          }
          value={formValues.classDescription}
          row={3}
          onChange={handleFormValueChange}
          errors={formErrors}
        /> */}
        <TwQuillEditor
          placeholder={t("myEvents.aboutThisEventPlaceholder2")}
          value={wrapContentIfNeeded(formValues.classDescription)}
          onChange={(html) => {

            setFormValues((prevValues) => ({
              ...prevValues,
              classDescription: html,
            }));
            // handleFormValueChange({ target: { name: "classDescription", value: html } })

          }}
        />
        <div className="flex justify-end w-full sm:w-full [sm:max-w-sm md:max-w-lg]">
          <TwButton
            variant={"default-box"}
            className="truncate"
            onClick={handleGenerate}
            disabled={gptLoading}
          >
            {gptLoading ? t("myEvents.generating") : (<><SparklesIcon className="size-5" /> {t("myEvents.generateByAIBtn")}</>)}

          </TwButton>
        </div>
      </div>
      {/* <TwSelectGroup
        label={t("myEvents.duration")}
        placeholder={t("myEvents.selectDuration")}
        name={"duration"}
        options={durationOpts.length ? durationOpts.map((duration, idx) => {
          return { value: duration, title: duration }
        }) : []}
        defaultValue={formValues.durationstring}
        value={formValues.durationstring}
        onChange={(event) => {
          const durationSplit = event.target.value.split(" ");
          const durationInNum = Number(durationSplit[0]) * 60 + Number(durationSplit[2]);
          setFormValues((prevValues) => ({
            ...prevValues,
            durationstring: event.target.value,
            duration: durationInNum,
          }));
        }}
        errors={formErrors} /> */}
      {/* <TwInputGroup
        label={t("myEvents.whatToCarry")}
        name={"whatToCarry"}
        value={formValues.whatToCarry}
        onChange={handleFormValueChange}
        errors={formErrors}
      /> */}
      {edit && (<div className={"flex gap-4 justify-center pt-5 w-full sm:w-full sm:max-w-sm md:max-w-lg mx-auto"}>
        <TwButton
          variant={"secondary-outline"}
          className={"w-full"}
          onClick={() => {
            // clearFormValues();
            handleCancel();
          }}
        >
          {t("inputFieldsTitle.cancel")}
        </TwButton>
        <TwButton
          variant={"secondary"}
          className={"w-full"}
          disabled={loadingReduxState.actionLoading}
          actionLoading={(loadingReduxState.actionLoading)}
          onClick={() => {
            if (edit) {
              handleUpdate();
            } else {
              handleSubmit();
            }
          }}
        >
          {edit ? t("update") : t("inputFieldsTitle.continue")}
        </TwButton>
      </div>)}
    </div>
  );
}
